import AbleChatbotList from '../able/ChatbotList';

// FastestForm brand reuses Able's chatbot list — same design
export default function ChatbotList() {
  return <AbleChatbotList />;
}
